import Vue from 'vue'
import Vuex from 'vuex'
import { adminLogin } from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: null
  },

  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      if (token) {
        localStorage.setItem('token', token)
      } else {
        localStorage.removeItem('token')
      }
    },
    SET_USER(state, userInfo) {
      state.userInfo = userInfo
    }
  },

  actions: {
    async login({ commit }, loginForm) {
      const res = await adminLogin(loginForm)
      commit('SET_TOKEN', res.data.token)
      commit('SET_USER', res.data.admin)
      return res
    },

    logout({ commit }) {
      commit('SET_TOKEN', '')
      commit('SET_USER', null)
    },

    async getUserInfo({ commit }) {
      // If we have a token but no userInfo, fetch from server
      // This can be called on app startup to restore session
    }
  }
})
